import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from '~/base/BaseServices.module.scss';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

// const DigitalTransformation = ({ t }) => {
const ItConsulting = () => {
    const { t } = useTranslation();
    let { pathname } = useLocation();

    const data = {
        title: t('IT Consulting Build'),
        indexClass: 3,
        titleTech: t('With a team steeped in deep'),
        video: 'https://video.wixstatic.com/video/c794a2_9943cfb9cc4d48dfa8df9ac8cfc4848d/720p/mp4/file.mp4',
        titleContent: t('IT Consulting'),
        poster: 'https://static.wixstatic.com/media/c794a2_9943cfb9cc4d48dfa8df9ac8cfc4848df000.jpg/v1/fill/w_761,h_532,al_c,q_85,usm_0.33_1.00_0.00,enc_auto/c794a2_9943cfb9cc4d48dfa8df9ac8cfc4848df000.jpg',
        content: t('We are committed to delivering'),
    };
    const detailServices = [
        {
            label: t('Digital Transformation'),
            description: t('Modernizing legacy systems, adopting AI/ML, IoT, and automation.'),
            image: require('../../assets/images/services/it-consulting/digital-transformation.png'),
        },
        {
            label: t('Cybersecurity & Risk Management'),
            description: t('Risk assessments, penetration testing, compliance (GDPR, HIPAA)'),
            image: require('../../assets/images/services/it-consulting/cybersecurity-risk-management.png'),
        },
        {
            label: t('Cloud Strategy & Migration'),
            description: t('Cloud adoption (AWS, Azure, GCP), hybrid cloud architecture'),
            image: require('../../assets/images/services/it-consulting/cloud-strategy-migration.png'),
        },
        {
            label: t('IT Infrastructure Optimization'),
            description: t('Network design, data center modernization, DevOps integration'),
            image: require('../../assets/images/services/it-consulting/it-infrastructure-optimization.png'),
        },
        {
            label: t('Software Development & Integration'),
            description: t('Custom app development, API integration, ERP/CRM implementation.'),
            image: require('../../assets/images/services/it-consulting/software-development-integration.png'),
        },
        {
            label: t('Data Analytics & Business Intelligence'),
            description: t('Building data warehouses, dashboards, predictive analytics models.'),
            image: require('../../assets/images/services/it-consulting/data-analytics-business-intelligence.png'),
        },
    ]
    const ctaData = {
        title: t('Allow your business move from big ideas to big results'),
        description: t('Our consulting efforts allow your business to multiply digital power on a global scale'),
    }

    return (
        <div className={cx('solution')}>
            <div className={cx('solution__intro')}>
                <div
                    className={cx('solution__intro-wraper')}
                    style={{
                        position: 'absolute',
                        maxWidth: '900px',
                        left: '110px',
                        top: '126px',
                    }}
                >
                    <div className={cx('solution__intro__title')}>{data.title}</div>
                    <div className={cx('solution__intro__description')}>{data.titleTech}</div>
                </div>
            </div>

            <div className={cx('solution__new', 'solution__new-service-' + data.indexClass)}>
                <div className={cx('solution__new__top')}>
                    <div className={cx('solution__new__top__content')}>{data.titleContent}</div>
                    <div className={cx('solution__new__top__content-two')}>
                        <p>{data.content}</p>
                    </div>
                </div>
                <div>
                    {window.innerWidth > 768 ? (
                        <video
                            crossOrigin="anonymous"
                            playSinline="true"
                            preload="auto"
                            loop
                            tabIndex="-1"
                            autoPlay
                            muted
                            src={data.video}
                            className="desktop-video"
                            style={{ width: '800px' }}
                        ></video>
                    ) : (
                        <img style={{ width: '100%' }} src={data.poster} alt="Mobile Image" />
                    )}
                </div>
            </div>
            {/* Services Grid Section */}
            <div className={cx("solution__services", "solution__services__" + pathname.split('/')[1])}>
                <div className={cx("solution__services__title")}>
                    {t("Our IT consulting services will help you achieve your business goals")}
                </div>

                <div className={cx("solution__services__description")}>
                    {t("We provide you expert advice and support, as well as implementing and managing your IT systems.")}
                </div>

                <div className={cx("solution__services__grid")}>
                    {detailServices.map((service, index) => (
                        <div className={cx("solution__services__item")}>
                            <div className={cx("solution__services__item__image")}>
                                <img src={service.image} alt={service.label} />
                            </div>
                            <div className={cx("solution__services__item__content")}>
                                <div className={cx("solution__services__item__content__text")}>
                                    <h3>{service.label}</h3>
                                    <p>{service.description}</p>
                                </div>
                                <div className={cx("solution__services__item__content__arrow")}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Call to Action Section */}
            <div className={cx("solution__cta")}>
                <div className={cx("solution__cta__content", "solution__cta__content__" + pathname.split('/')[1])}>
                    <div className={cx("solution__cta__text")}>
                        <h2>{ctaData.title}</h2>
                        <p>{ctaData.description}</p>
                        <Link to="/contact" className={cx("solution__cta__button")}>
                            {t("CONTACT US >")}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ItConsulting
